<template>
    <div>
        <modal :close="closeModal" :show="showModal">
            <template v-slot:header>
                <h1 class="header"> {{ $t("modal.cancel.header") }} </h1>
            </template>

            <template v-slot:body>
                <div class="body-text">
                    {{ $t("modal.cancel.body") }}
                </div>
            </template>

            <template v-slot:footer>
                <div class="text-right">
                    <button class="yes-button" @click="closeModal(true)">Yes</button>
                    <button class="no-button" @click="closeModal(false)">No</button>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
    import Modal from "./Modal";
    import { applyService, workflowService } from "@/service"
    import FinishApplyAction from "@/action/actions/FinishApplyAction"
    import FinishType from "@/model/apply/FinishType"

    export default {
        name: "CancelApplicationModal",
        components: {
            Modal
        },
        props: {
            showModal: {
                type: Boolean,
                default: false,
            }
        },
        methods: {
            async closeModal(cancel) {
                this.$emit("close-cancel-modal", cancel)
                if (cancel === true) {
                    await workflowService.invoke(new FinishApplyAction(FinishType.CANCEL))
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .overflow-hidden {
        overflow: hidden;
    }

    .header {
        padding-top: to_rem(24px);
        padding-bottom: to_rem(16px);
        font-style: normal;
        font-weight: 600;
        font-size: to_rem(26px);
        line-height: to_rem(32px);
        letter-spacing: -0.5px;
        color: $primary-color;
    }

    .body-text {
        font-weight: 400;
        font-size: to_rem(18px);
        color: $grey-darken-2;
        line-height: to_rem(28px);
    }

    .yes-button {
        float: right;
        font-size: to_rem(18px);
        margin: 0px 8px;
        color: $secondary-color;
        width: 31px;
        height: 20px;
    }

    .no-button {
        float: right;
        font-size: to_rem(18px);
        margin: 0px 8px;
        width: 25px;
        height: 20px;
    }
</style>
